import { useState, useEffect } from "react";
import {
  loadWarehouseEnvironmentList,
  loadWarehouseEnvironmenttypeListByStatus,
} from "../../services/warehouseService";

const useWarehouseEnvironmentTypeList = (status, editID) => {
  const [warehouseEnvironmentTypes, setWarehouseEnvironmentTypes] = useState([]);
  const [selectedWarehouseEnvironmentType, setSelectedWarehouseEnvironmentType] = useState(null);
  const [selectedWarehouseEnvironmentTypeID, setSelectedWarehouseEnvironmentTypeID] = useState(null);
  const [isWarehouseEnvironmentTypeDataLoaded, setIsWarehouseEnvironmentTypeDataLoaded] = useState(false);

  const fetchWarehouseEnvironmentTypeList = async (selectedID = null) => {
    try {
      let data = [];

      // 🔹 Step 1: Try to load by status (active/inactive)
      if (status !== null) {
        const para = {
          p_company_id: localStorage.getItem("companyid"),
          p_plant_id: 1,
          p_status: status,
        };
        data = await loadWarehouseEnvironmenttypeListByStatus(para);
      } else {
        data = await loadWarehouseEnvironmentList({
          p_companyid: localStorage.getItem("companyid"),
        });
      }

      // 🔹 Step 2: Fallback — if no active found, load all
      if ((!data || data.length === 0) && status === true && selectedID) {
        data = await loadWarehouseEnvironmentList({
          p_companyid: localStorage.getItem("companyid"),
        });
      }

      // 🔹 Step 3: Continue like before
      if (data && data.length > 0) {
        let updatedList = [...data];
        let initialType = data.find((t) => t.environment_type_id === selectedID);

        if (!initialType && selectedID) {
          const allData = await loadWarehouseEnvironmentList({
            p_companyid: localStorage.getItem("companyid"),
          });
          const inactiveType = allData.find((t) => t.environment_type_id === selectedID);
          if (inactiveType) {
            updatedList.push(inactiveType);
            initialType = inactiveType;
          }
        }

        setWarehouseEnvironmentTypes(updatedList);
        if (initialType) {
          setSelectedWarehouseEnvironmentType(initialType);
          setSelectedWarehouseEnvironmentTypeID(initialType.environment_type_id);
        }

        setIsWarehouseEnvironmentTypeDataLoaded(true);
      }
      else
      {
         setSelectedWarehouseEnvironmentType(null);
          setSelectedWarehouseEnvironmentTypeID(null);
           setIsWarehouseEnvironmentTypeDataLoaded(true);
            setWarehouseEnvironmentTypes([]);
      }
    } catch (error) {
      console.error("Error fetching warehouse environment types:", error);
    }
  };

  useEffect(() => {
    if (!isWarehouseEnvironmentTypeDataLoaded && editID === 0) {
      fetchWarehouseEnvironmentTypeList();
    }
  }, [isWarehouseEnvironmentTypeDataLoaded, editID]);

  const loadWarehouseEnvironmentTypeByID = async (selectedID) => {
    await fetchWarehouseEnvironmentTypeList(selectedID);
  };

  return {
    warehouseEnvironmentTypes,
    selectedWarehouseEnvironmentType,
    selectedWarehouseEnvironmentTypeID,
    setSelectedWarehouseEnvironmentType,
    setSelectedWarehouseEnvironmentTypeID,    
    loadWarehouseEnvironmentTypeByID,
  };
};

export default useWarehouseEnvironmentTypeList;
